<template>
  <v-container-fluid>
    <!-- Prvi red -->
    <v-row>
      <v-col cols="12" md="12">
        <div><tools-transcribe /></div>
      </v-col>
    </v-row>
    <!-- Drugi red -->
    <v-row v-if="canViewAllUsers">
      <v-col cols="12" md="12">
        <div><all-users /></div>
      </v-col>
    </v-row>
  </v-container-fluid>
</template>

<script>
import secureStorage from '@/utils/secureStorage';
import weather from "@/components/dashboard/weather.vue";
import AllUsers from "@/components/admin/AllUsers.vue";
import ToolsTranscribe from "@/components/dashboard/toolsTranscribe.vue";
export default {
  components: {
    weather,
    AllUsers,
    ToolsTranscribe,
  },
  computed: {
    canViewAllUsers() {
      const user = secureStorage.getItem("user");
      return user && user.role_id !== 1;
    },
  },
};
</script>
<style scoped>
.content-container.box {
  margin: 0 !important;
}
</style>
